// extracted by mini-css-extract-plugin
module.exports = {"SnippetCarouselItemBorderedMore":"snippet-carousel-item-bordered-more_SnippetCarouselItemBorderedMore__GJZ5k"};